<template>
  <div class="product-sold rounded mb-4 p-4"
       v-loading="loading"
       element-loading-text="Loading..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <p class="text-white font-bold text-xl">Product Sold</p>
    <GChart
      type="LineChart"
      :data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: 'product_sold',
  data() {
    return {
      loading: false,
      chartOptions: {
        curveType: 'function',
        legend: { position: 'none' },
        backgroundColor: 'none',
        vAxis: {
          baselineColor: 'none',
          textPosition: 'none',
          gridlines: {
            color: 'none',
          },
        },
        hAxis: { textPosition: 'none' },
        chartArea: {
          // left: '6%',
          width: '100%',
          height: '100%',
        },
        colors: ['#ffffff'],
      },
      chartEvents: {
        ready: () => {
          console.log('hello');
          this.loading = false;
        },
        error: () => {
          this.loading = true;
        },
      },
    };
  },
  components: {
    GChart,
  },

  computed: {
    chartData() {
      return this.$store.getters['Dashboard/totalProductsSold'];
    },
  },
  async mounted() {
    await this.$store.dispatch('Dashboard/fetchProductSales');
  },
};
</script>

<style scoped lang="scss">
.product-sold {
  height: auto;
  background-image: linear-gradient(to top, #fd1b57, #ff7c90);

  >:nth-child(5) {
    top: -40px;
  }
}
</style>
